import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col, Row, FormGroup, Label, CustomInput, Modal } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  createFoodCuisine,
  updateFoodCuisine,
  getFoodCuisineById,
  getFoodCuisineList,
  removeFoodCuisine,
} from "../../Endpoint/Admin/index";
import { toast } from "react-toastify";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Panel, Btn, SearchPill, StatRow, StatCard, Thumb, ConfirmDialog,
} from "../../components/Console/ConsoleUI";
import { canWrite } from "../../services/PermissionService";

/**
 * Food cuisines — the photo tiles the guest app shows above the menu.
 *
 * A cuisine record is a name and a photograph and nothing else (the list
 * endpoint strips isActive and both timestamps), so the screen follows the
 * console's shape for that kind of record — the same card grid the attractions
 * catalogue uses — rather than a table where the photo would shrink to a
 * thumbnail in the column it matters most in.
 *
 * Re-skin only: createFoodCuisine / updateFoodCuisine still post the same
 * multipart FormData, and the list still comes from getFoodCuisineList().
 */

const CSS = `
.fc-card{background:#fff;border:1px solid ${C.tint};border-radius:18px;overflow:hidden;
  display:flex;flex-direction:column}
.fc-act{border:0;background:transparent;padding:0;font-family:inherit;font-size:13px;
  font-weight:500;color:${C.brown};cursor:pointer;display:flex;align-items:center;gap:6px}
.fc-act:hover{text-decoration:underline}
.fc-act.is-danger{color:${C.red}}
.fc-newtile{border:1px dashed #dfcdb2;border-radius:18px;display:flex;flex-direction:column;
  align-items:center;justify-content:center;gap:9px;color:${C.taupeLight};min-height:210px;
  cursor:pointer;background:transparent;font-family:inherit;font-size:14px;width:100%}
.fc-newtile:hover{border-color:${C.brown};color:${C.brown}}
`;

/** Pill row across the food family - see food/index.js. */
const NavPills = ({ items, active }) => (
  <div style={{ display: "flex", padding: 4, borderRadius: 21, background: "#efe2ce" }}>
    {items.map((i) => (
      <Link
        key={i.to}
        to={i.to}
        style={{
          padding: "8px 16px", borderRadius: 17, fontSize: 14, textDecoration: "none",
          whiteSpace: "nowrap",
          background: i.to === active ? C.brown : "transparent",
          color: i.to === active ? "#fff" : C.taupe,
        }}
      >
        {i.label}
      </Link>
    ))}
  </div>
);


class Foodcuisine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      previewImage: undefined,
      items: [],
      isLoaded: false,
      modal: false,
      cuisineName: "",
      foodCuisineId: null,
      selectedFile: null, // to store selected file
      handleResponse: null, // handle the API response
      invalidImage: null,
      selectedFileName: "",
      // View-only state — never changes what is fetched.
      search: "",
      showDeleteModal: false,
      pendingDelete: null,
      actionLoading: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.getALlluser = this.getALlluser.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      cuisineName: "",
      foodCuisineId: "",
      previewImage: "",
      invalidImage: "",
      selectedOption: null,
    });
  }

  handleCloseModal() {
    this.setState({
      modal: false,
    });
  }

  onFileChange(event) {
    // Keep the file off the pooled synthetic event rather than re-reading it.
    const imageFile = event.target.files[0];
    if (!imageFile) return false;

    if (!imageFile.name.match(/\.(jpg|jpeg|png)$/)) {
      this.setState({
        invalidImage: "Please select valid image.",
        previewImage: URL.createObjectURL(imageFile),
      });
      return false;
    } else {
      this.setState({
        selectedFile: imageFile,
        previewImage: URL.createObjectURL(imageFile),
        invalidImage: null,
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  handleSubmit() {
    // AvForm has already blocked the browser's own submit before calling this.
    const formData = new FormData();
    formData.append("cuisineName", this.state.cuisineName);
    formData.append("foodCuisineId", this.state.foodCuisineId);

    formData.append("foodCuisine", this.state.selectedFile);

    if (this.state.foodCuisineId == "" || this.state.foodCuisineId == null) {
      createFoodCuisine(formData)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                cuisineName: "",
                selectedFile: null, // to store selected file
                handleResponse: null, // handle the API response
                imageUrl: null, // to store uploaded image path
                invalidImage: null,
                selectedFileName: "",
                previewImage: "",
                foodCuisineId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success(" Food cuisine added successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateFoodCuisine(formData)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",
                foodCuisineId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();

            toast.success("Food cuisine  updated successfully");
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  getALlluser() {
    getFoodCuisineList().then((result) => {
      this.setState({
        isLoaded: true,
        items: (result && result.data) || [],
      });
    });
  }

  componentDidMount() {
    this.getALlluser();
  }

  editfoodCuisine(id) {
    getFoodCuisineById(id)
      .then((results) => {
        this.setState({
          cuisineName: results.data.cuisineName,
          previewImage: results.data.cuisineImage,
          selectedFile: results.data.cuisineImage,
          foodCuisineId: results.data._id,
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.setState({ modal: true });
  }

  removefoodcuisine(id) {
    this.setState({ actionLoading: true });
    removeFoodCuisine(id)
      .then((results) => {
        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      })
      .finally(() => {
        this.setState({
          actionLoading: false,
          showDeleteModal: false,
          pendingDelete: null,
        });
      });
  }

  // --- presentation ---------------------------------------------------------

  askDelete = (c) => this.setState({ showDeleteModal: true, pendingDelete: c });

  toggleDeleteModal = () =>
    this.setState({
      showDeleteModal: !this.state.showDeleteModal,
      pendingDelete: null,
    });

  /** Client-side filter over the loaded list. No request is made. */
  visibleCuisines() {
    const q = this.state.search.trim().toLowerCase();
    if (!q) return this.state.items || [];
    return (this.state.items || []).filter((c) =>
      String(c.cuisineName || "").toLowerCase().includes(q)
    );
  }

  renderCard(c) {
    const write = canWrite();
    return (
      <div key={c._id} className="fc-card">
        <div style={{ height: 132, background: C.iconTint }}>
          <Thumb src={c.cuisineImage} alt={c.cuisineName} icon="restaurant_menu" height={132} />
        </div>
        <div style={{ padding: "15px 17px", display: "flex", flexDirection: "column", flex: 1 }}>
          <div style={{ fontSize: 12, color: C.taupeLight, letterSpacing: ".6px" }}>CUISINE</div>
          <div style={{ marginTop: 4, fontSize: 16, fontWeight: 500, color: C.ink }}>
            {c.cuisineName || "Untitled cuisine"}
          </div>
          <div style={{ marginTop: 6, fontSize: 13, color: c.cuisineImage ? C.taupe : C.taupeLight }}>
            {c.cuisineImage ? "Photo uploaded" : "No photo yet"}
          </div>

          {/* Write controls stay behind canWrite(): a view-only account still
              sees every cuisine, just no way to change one. */}
          {write && (
            <div
              style={{
                marginTop: 14,
                paddingTop: 12,
                borderTop: `1px solid ${C.panel}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <button
                type="button"
                className="fc-act"
                onClick={() => this.editfoodCuisine(c._id.toString())}
              >
                Edit
                <span className="ms" style={{ fontSize: 17, color: C.taupeLight }}>edit</span>
              </button>
              <button
                type="button"
                className="fc-act is-danger"
                aria-label={`Remove ${c.cuisineName || "cuisine"}`}
                title={`Remove ${c.cuisineName || "cuisine"}`}
                onClick={() => this.askDelete(c)}
              >
                <span className="ms" style={{ fontSize: 17 }}>delete</span>
              </button>
            </div>
          )}
        </div>
      </div>
    );
  }

  renderModal() {
    const { handleResponse, invalidImage, previewImage, foodCuisineId } = this.state;
    const editing = !!foodCuisineId;

    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle} className="con-modal" centered>
        <div style={{ padding: 30 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <span
              className="ms"
              style={{
                fontSize: 26,
                color: C.brown,
                background: C.iconTint,
                padding: 13,
                borderRadius: 16,
              }}
            >
              restaurant_menu
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 22, fontWeight: 500, color: C.ink }}>
                {editing ? "Edit cuisine" : "Add cuisine"}
              </div>
              <div style={{ marginTop: 4, fontSize: 14, color: C.taupe }}>
                {editing
                  ? "Changes reach the guest app as soon as you save"
                  : "Cuisines head the menu in the guest app"}
              </div>
            </div>
            <button
              type="button"
              onClick={this.toggle}
              aria-label="Close"
              style={{
                border: 0,
                background: "transparent",
                color: C.taupeLight,
                cursor: "pointer",
                padding: 4,
                lineHeight: 1,
              }}
            >
              <span className="ms" style={{ fontSize: 22 }}>close</span>
            </button>
          </div>

          <AvForm onValidSubmit={this.handleSubmit}>
            <div style={{ marginTop: 24, display: "flex", gap: 18, alignItems: "flex-start" }}>
              {/* The real file input is unchanged — only hidden, and driven by
                  the tile beside it, so the multipart payload is identical. */}
              <div style={{ display: "none" }}>
                <AvField
                  tag={CustomInput}
                  name="file"
                  id="file"
                  type="file"
                  accept="image/*"
                  onChange={this.onFileChange}
                />
              </div>
              <label
                htmlFor="file"
                style={{
                  width: 132,
                  height: 132,
                  borderRadius: 16,
                  border: "1.5px dashed #d9c3a5",
                  background: "#fff",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  color: C.taupeLight,
                  cursor: "pointer",
                  margin: 0,
                  flex: "0 0 132px",
                  overflow: "hidden",
                }}
              >
                {previewImage ? (
                  <Thumb
                    src={previewImage}
                    alt="Selected cuisine"
                    icon="restaurant_menu"
                    height={132}
                    width={132}
                  />
                ) : (
                  <React.Fragment>
                    <span className="ms" style={{ fontSize: 26 }}>add_photo_alternate</span>
                    <span style={{ fontSize: 12 }}>Upload photo</span>
                  </React.Fragment>
                )}
              </label>

              <div style={{ flex: 1, minWidth: 0 }}>
                <Row form>
                  <Col md={12}>
                    <FormGroup>
                      <Label for="cuisineName">Cuisine name</Label>
                      <AvField
                        type="text"
                        value={this.state.cuisineName}
                        onChange={this.handleChange}
                        id="cuisineName"
                        name="cuisineName"
                        placeholder="e.g. Congolese"
                        required
                                  errorMessage="Cuisine name is required"
                                />
                    </FormGroup>
                  </Col>
                </Row>
                <div style={{ fontSize: 12, color: C.taupeLight }}>
                  JPG or PNG. The photo is what guests see first.
                </div>
              </div>
            </div>

            {invalidImage && (
              <p style={{ marginTop: 12, marginBottom: 0, color: C.red, fontSize: 13 }}>
                {invalidImage}
              </p>
            )}
            {this.state.selectedFileName && (
              <p style={{ marginTop: 8, marginBottom: 0, fontSize: 13, color: C.taupe }}>
                {this.state.selectedFileName}
              </p>
            )}
            {handleResponse && (
              <p
                style={{
                  marginTop: 12,
                  marginBottom: 0,
                  fontSize: 13,
                  color: handleResponse.isSuccess ? C.green : C.red,
                }}
              >
                {handleResponse.message}
              </p>
            )}

            <div style={{ marginTop: 24, display: "flex", gap: 12 }}>
              <button
                type="button"
                onClick={this.toggle}
                style={{
                  flex: 1,
                  height: 52,
                  border: "1px solid #e6d8c4",
                  borderRadius: 26,
                  background: "#fff",
                  color: C.slate,
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>
              {/* Stays a real submit button — AvForm validates on submit. */}
              <button
                type="submit"
                style={{
                  flex: 1,
                  height: 52,
                  border: 0,
                  borderRadius: 26,
                  background: C.brown,
                  color: "#fff",
                  fontFamily: "inherit",
                  fontSize: 15,
                  cursor: "pointer",
                }}
              >
                {editing ? "Save changes" : "Add cuisine"}
              </button>
            </div>
          </AvForm>
        </div>
      </Modal>
    );
  }

  render() {
    const { items, isLoaded, search, pendingDelete } = this.state;
    const write = canWrite();
    const visible = this.visibleCuisines();
    const withPhoto = (items || []).filter((c) => !!c.cuisineImage).length;

    return (
      <ConsolePage
        title="Food cuisines"
        subtitle={
          isLoaded
            ? `${(items || []).length} cuisine${(items || []).length === 1 ? "" : "s"}${
                search.trim() ? ` · ${visible.length} matching` : ""
              }`
            : "Loading cuisines…"
        }
        actions={
          <React.Fragment>
            <NavPills
              active="/Foodcuisine"
              items={[
                { to: "/Food", label: "Menu & items" },
                { to: "/FoodOrder", label: "Orders" },
                { to: "/Foodcuisine", label: "Cuisines" },
              ]}
            />
            <SearchPill
              value={search}
              onChange={(v) => this.setState({ search: v })}
              placeholder="Search cuisines"
              width={220}
            />
            {write && (
              <Btn icon="add" onClick={this.toggle}>
                Add cuisine
              </Btn>
            )}
          </React.Fragment>
        }
      >
        <style dangerouslySetInnerHTML={{ __html: CSS }} />

        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
          <StatRow columns={3}>
            <StatCard icon="restaurant_menu" value={(items || []).length} label="Cuisines" />
            <StatCard icon="photo_library" value={withPhoto} label="With a photo" />
            <StatCard
              icon="image_not_supported"
              value={(items || []).length - withPhoto}
              label="Missing a photo"
            />
          </StatRow>

          <Panel
            title="All cuisines"
            subtitle="Each one is a tile at the top of the guest app's food menu"
            actions={
              <span style={{ fontSize: 14, color: C.taupeLight }}>
                {visible.length} of {(items || []).length} shown
              </span>
            }
          >
            {!isLoaded ? (
              <div style={{ padding: "50px 0", textAlign: "center", color: C.taupeLight }}>
                Loading cuisines…
              </div>
            ) : (
              <div
                style={{
                  marginTop: 18,
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(215px, 1fr))",
                  gap: 18,
                }}
              >
                {visible.map((c) => this.renderCard(c))}

                {write && (
                  <button type="button" className="fc-newtile" onClick={this.toggle}>
                    <span className="ms" style={{ fontSize: 26 }}>add_photo_alternate</span>
                    <span>Add a cuisine</span>
                  </button>
                )}

                {visible.length === 0 && !write && (
                  <div style={{ padding: "50px 0", color: C.taupeLight }}>
                    {(items || []).length === 0
                      ? "No cuisines yet."
                      : "No cuisine matches that search."}
                  </div>
                )}
              </div>
            )}
          </Panel>
        </div>

        {this.renderModal()}

        <ConfirmDialog
          isOpen={this.state.showDeleteModal}
          toggle={this.toggleDeleteModal}
          onConfirm={() =>
            pendingDelete && this.removefoodcuisine(pendingDelete._id.toString())
          }
          icon="delete"
          title={`Remove ${pendingDelete ? pendingDelete.cuisineName : "this cuisine"}?`}
          body="It disappears from the guest app's food menu straight away."
          tip="Deleting cannot be undone — you would have to add the cuisine and its photo again."
          confirmText="Remove"
          loading={this.state.actionLoading}
        />
      </ConsolePage>
    );
  }
}

export default Foodcuisine;
